var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z",
    fill: "#85A5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 14.25L23.0625 13.5312C22.75 13.25 22.2812 13.25 22 13.5312L21.8125 13.7188L18.2812 10.1875L18.4688 10C18.75 9.71875 18.75 9.25 18.4688 8.9375L17.75 8.25C17.4688 7.9375 17 7.9375 16.6875 8.25L12.8125 12.125C12.5 12.4062 12.5 12.9062 12.8125 13.1875L13.5 13.9062C13.8125 14.1875 14.2812 14.1875 14.5625 13.9062L14.75 13.7188L16 14.9375L13.4688 17.5L13.2812 17.3125C12.875 16.9062 12.25 16.9062 11.875 17.3125L8.28125 20.9062C7.875 21.2812 7.875 21.9062 8.28125 22.3125L9.6875 23.7188C10.0938 24.125 10.7188 24.125 11.0938 23.7188L14.6875 20.125C15.0938 19.75 15.0938 19.125 14.6875 18.7188L14.5 18.5312L17.0625 16L18.2812 17.25L18.0938 17.4375C17.8125 17.7188 17.8125 18.1875 18.0938 18.5L18.8125 19.1875C19.0938 19.5 19.5938 19.5 19.875 19.1875L23.75 15.3125C24.0625 15 24.0625 14.5312 23.75 14.25Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBid);
export default __webpack_public_path__ + "static/media/icon-bid.a28e40f9.svg";
export { ForwardRef as ReactComponent };